module.exports = __webpack_public_path__ + "static/media/OrderNotificationMusic_Kitchen3.07f0310b.mp3";